<template>
	<div class="user-center-container">
		<!-- <div class="user-center-header filter-container">
			<div class="form-header">
				<h3 class="form-title">监控设置</h3>
			</div>
		</div> -->
		<div class="user-center-content">
			<div v-loading="loading" class="table-list-container">
				<table class="table">
					<thead>
						<tr>
							<th class="header-item">监控类型</th>
							<th class="header-item">监控维度</th>
							<th class="header-item">信息通知</th>
							<th class="header-item">操作</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in settingList.filter(i => i.monitoringType === '3')" :key="item.id" class="table-row">
							<td v-if="index === 0" class="row-item" :rowspan="settingList.filter(i => i.monitoringType === '3').length">
								企业
							</td>
							<td class="row-item">{{ item.monitoringDimensionName }}</td>
							<td class="row-item">消息提示</td>
							<td class="row-item">
								<el-switch
									v-model="item.switchStatus"
									active-color="#13ce66"
									inactive-color="#ff4949"
									:active-value="1"
									:inactive-value="0"
									@change="value => changeMonitorSettings(item, value)"
									:disabled="!isSVip"
								></el-switch>
							</td>
						</tr>
						<tr v-for="(item, index) in settingList.filter(i => i.monitoringType === '2')" :key="item.id" class="table-row">
							<td v-if="index === 0" class="row-item" :rowspan="settingList.filter(i => i.monitoringType === '2').length">
								人员
							</td>
							<td class="row-item">{{ item.monitoringDimensionName }}</td>
							<td class="row-item">消息提示</td>
							<td class="row-item">
								<el-switch
									v-model="item.switchStatus"
									active-color="#13ce66"
									inactive-color="#ff4949"
									:active-value="1"
									:inactive-value="0"
									@change="value => changeMonitorSettings(item, value)"
									:disabled="!isSVip"
								></el-switch>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<!-- 未开通超级会员提示 -->
		<NonbindSVip v-if="!isSVip"></NonbindSVip>
	</div>
</template>

<script>
	import NonbindSVip from '@/components/NonBind/nonbindSVip.vue'
	import { mapGetters } from 'vuex'
	import { listUserMonitoring, saveOrUpdateUserMonitoring } from '@/api/user/monitor'
	export default {
		name: 'MonitorSettings',
		components: { NonbindSVip },
		props: {},
		data() {
			return {
				loading: false,
				settingList: []
			}
		},
		computed: {
			...mapGetters(['userId', 'vipLevel', 'isNormalVip', 'isVip', 'isSVip'])
		},
		watch: {},
		created() {},
		mounted() {
			if (this.isSVip) {
				this.initUserMonitor()
			} else {
				// 如果不是vip就默认数据展示
				this.settingList = [
					{
						id: '0568d609df624e53ac9ccfed37b8daf3',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '3',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '1',
						monitoringDimensionName: '注册变更',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 1
					},
					{
						id: 'e32a271201244c2eb5c267013ff529e5',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '3',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '2',
						monitoringDimensionName: '分立变更',
						msgNotice: null,
						switchStatus: 1,
						sortNo: 2
					},
					{
						id: 'd3c759ed37664861aa290760e433fef5',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '3',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '3',
						monitoringDimensionName: '吸收变更',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 3
					},
					{
						id: '42d1779164614542b09721da9834cacf',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '3',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '4',
						monitoringDimensionName: '黑名单',
						msgNotice: null,
						switchStatus: 1,
						sortNo: 4
					},
					{
						id: '09aec66e7e3741858586561b1c8e144e',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '3',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '5',
						monitoringDimensionName: '行政处罚',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 5
					},
					{
						id: '0994713d61fd4021bf187c8d1a3aebc0',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '3',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '6',
						monitoringDimensionName: '良好行为',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 6
					},
					{
						id: '26f3a57fee554f6e97d3db665b60a6cf',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '3',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '7',
						monitoringDimensionName: '不良行为',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 7
					},
					{
						id: '6147e15b681740ad86001b66938f0591',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '3',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '8',
						monitoringDimensionName: '资质注册',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 8
					},
					{
						id: '1ed3300021284395bb3d8ec4202c3637',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '3',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '9',
						monitoringDimensionName: '资质注销',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 9
					},
					{
						id: '3af25cf6ebc84c8dbd7935dc3e2822c9',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '2',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '101',
						monitoringDimensionName: '良好行为',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 101
					},
					{
						id: 'a2ebfc65d0954741a09778fa9719ba3f',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '2',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '102',
						monitoringDimensionName: '不良行为',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 102
					},
					{
						id: 'd85bbbdfd688448b9ff64004c68767e6',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '2',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '103',
						monitoringDimensionName: '行政处罚',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 103
					},
					{
						id: 'd1a7e0b19d544ae0b1ece9fe4c2610ee',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '2',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '104',
						monitoringDimensionName: '黑名单记录',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 104
					},
					{
						id: 'ddabf7d018274bc68525d1586d85f881',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '2',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '105',
						monitoringDimensionName: '黑名单及联合惩戒',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 105
					},
					{
						id: '9dd0e1dd11b34b53ae8c8eb0eb8de010',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '2',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '106',
						monitoringDimensionName: '资质注册',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 106
					},
					{
						id: '4e8ffb6b1f5348f9ae0d1a50d739eda3',
						createBy: null,
						createTime: null,
						updateBy: null,
						updateTime: null,
						rowState: 1,
						remark: null,
						monitoringType: '2',
						userId: '427cac69fbe94722bb77e7d6a3fc32b1',
						monitoringDimensionCode: '107',
						monitoringDimensionName: '资质注销',
						msgNotice: null,
						switchStatus: 0,
						sortNo: 107
					}
				]
			}
		},
		methods: {
			initUserMonitor() {
				// TODO: 初始化用户监控
				this.loading = true
				listUserMonitoring()
					.then(res => {
						this.settingList = res.data
						this.loading = false
					})
					.catch(err => {
						this.settingList = []
						this.loading = false
					})
			},
			changeMonitorSettings(item, newValue) {
				this.settingList.forEach(f => {
					if (item.id === f.id) {
						f.switchStatus = newValue
					}
				})
				saveOrUpdateUserMonitoring({ configList: this.settingList }).then(res => {
					this.$message.success('修改成功')
					this.initUserMonitor()
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
	.user-center-container {
		position: relative;
	}
	.table-list-container {
		.table {
			width: 100%;
			border-collapse: collapse;
			font-size: 16px;

			thead {
				border: 1px solid #c8def3;
				tr {
					th {
						padding: 12px 0;
						text-align: center;
						font-weight: normal;
						background-color: #dceaf7;
						color: #3479ce;
						border-right: 1px solid #c8def3;
					}
				}
			}

			tbody {
				tr.table-row {
					border: 1px solid #c8def3;
					text-align: center;

					&:hover {
						background-color: #f5f7fa;
					}

					td.row-item {
						padding: 12px 0;
						vertical-align: middle;
						border-right: 1px solid #c8def3;
					}
				}
			}
		}
	}
</style>
